import { useMemo } from "react";
import { useRetriesForJob } from "~/components/build/Show/lib/BuildContext";
import { CommandJob } from "~/components/build/Show/lib/types";
import { Step } from "~/lib/pipeline";

const RetryLabel = ({ retryCount }: { retryCount: number }) => {
  if (retryCount === 0) {
    return null;
  }

  return (
    <span className="text-charcoal-500 text-xs font-medium underline decoration-gray-600 decoration-dashed underline-offset-2">
      {retryCount > 1 ? `${retryCount} retries` : `${retryCount} retry`}
    </span>
  );
};

/** @deprecated Use `~/components/build/Show/routes/list/-components/TreeNode/JobRetries` instead. */
export function StepRetries({ step }: { step: Step }) {
  const retryCount = useMemo(() => {
    return step.statistics?.retriesCount || 0;
  }, [step]);

  if (retryCount === 0) {
    return null;
  }

  return <RetryLabel retryCount={retryCount} />;
}

/** @deprecated Use `~/components/build/Show/routes/list/-components/TreeNode/JobRetries` instead. */
export function JobRetries({ job }: { job: CommandJob }) {
  const jobs = useRetriesForJob(job);
  const retryCount = jobs.length - 1;

  if (!jobs.length) {
    return null;
  }

  return <RetryLabel retryCount={retryCount} />;
}
